import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';
import React, { FC } from 'react';

const TroubleshootingMultipleChoiceField: FC<any> = ({
	isGroupField,
	name = 'multipleChoices',
}): React.ReactElement => {
	return (
		<Form.List name={name}>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name: optionName, ...restField }) => (
						<Space
							key={key}
							style={{ display: 'flex', width: '100%' }}
							align="baseline"
							className="troubleshooting-step"
						>
							<Form.Item
								{...restField}
								style={{ width: '100%', marginBottom: '8px' }}
								name={isGroupField ? optionName : [optionName, 'value']}
								rules={[{ required: true, message: 'Missing Value' }]}
							>
								<Input
									style={{ width: '100%' }}
									placeholder={`Option`}
									suffix={
										<DeleteOutlined
											style={{ cursor: 'pointer' }}
											onClick={() => remove(optionName)}
										/>
									}
								/>
							</Form.Item>
						</Space>
					))}
					<Form.Item>
						<Button type="link" onClick={() => add()} icon={<PlusOutlined />}>
							Add Option
						</Button>
					</Form.Item>
				</>
			)}
		</Form.List>
	);
};

export default TroubleshootingMultipleChoiceField;
